<template>
  <div class="subscription-orders">
    <div class="page-header">
      <h2>Subscription Orders</h2>
    </div>

    <el-card class="orders-card">
      <el-table
        v-loading="loading"
        :data="orders"
        style="width: 100%"
        :header-cell-class-name="'custom-head-cell'"
        :row-class-name="'custom-row-bg'"
      >
        <el-table-column prop="_id.$id" label="Order ID" width="240"></el-table-column>

        <el-table-column label="Quantity" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.quantity }} seats
          </template>
        </el-table-column>

        <el-table-column label="Duration" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.duration_months }} months
          </template>
        </el-table-column>

        <el-table-column label="Amount" width="120" align="center">
          <template slot-scope="scope">
            ${{ formatPrice(scope.row.total_price) }}
          </template>
        </el-table-column>

        <el-table-column label="Order Date" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.order_time * 1000) }}
          </template>
        </el-table-column>

        <el-table-column label="Status" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="Actions" width="140" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 'PENDING'"
              type="primary"
              size="small"
              @click="goToPayment(scope.row)"
            >
              Pay Now
            </el-button>
            <el-button
              v-else-if="scope.row.status === 'COMPLETED'"
              type="text"
              size="small"
              @click="viewQuotas"
            >
              View Quotas
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="empty-state" v-if="!loading && orders.length === 0">
        <i class="el-icon-document"></i>
        <p>No subscription orders found</p>
        <el-button type="primary" @click="goToOrderForm">Purchase Subscriptions</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { postRequest } from '@/api/eclub'
import { getUserId, getAccountId } from '@/utils/store'

export default {
  name: 'SubscriptionOrders',
  data() {
    return {
      orders: [],
      loading: false,
      accountId: ''
    }
  },
  async created() {
    await this.resolveAccountId()
    this.fetchOrders()
  },
  methods: {
    async resolveAccountId() {
      const storedAccountId = getAccountId()
      if (storedAccountId) {
        this.accountId = storedAccountId
        return
      }
      try {
        const response = await postRequest('getAdvisorClubs', {
          advisor_id: getUserId()
        })
        if (response.data.code === 0 && response.data.data && response.data.data.length > 0) {
          this.accountId = response.data.data[0].account_id
        }
      } catch (error) {
        console.error('Error fetching account ID:', error)
      }
    },
    async fetchOrders() {
      if (!this.accountId) return
      this.loading = true
      try {
        const response = await postRequest('getAccountSubscriptionOrders', {
          account_id: this.accountId
        })
        if (response.data.code === 0) {
          this.orders = response.data.data
        }
      } catch (error) {
        console.error('Error fetching orders:', error)
        this.$message.error('Failed to load subscription orders')
      } finally {
        this.loading = false
      }
    },
    formatPrice(value) {
      if (value === null || value === undefined) return '0.00'
      return Number(value).toFixed(2)
    },
    formatDate(timestamp) {
      if (!timestamp) return '-'
      return new Date(timestamp).toLocaleString()
    },
    getStatusType(status) {
      const types = {
        PENDING: 'warning',
        COMPLETED: 'success',
        CANCELLED: 'info',
        FAILED: 'danger'
      }
      return types[status] || 'info'
    },
    goToPayment(order) {
      this.$router.push({
        path: '/home/subscriptionPayment',
        query: { order_id: order._id.$id }
      })
    },
    viewQuotas() {
      this.$router.push({
        path: '/home/subscriptionManagement'
      })
    },
    goToOrderForm() {
      this.$router.push({
        path: '/home/subscriptionOrderForm'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.subscription-orders {
  padding: 20px;

  .page-header {
    margin-bottom: 20px;

    h2 {
      margin: 0;
      color: #303133;
    }
  }

  .orders-card {
    .content-info {
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }

  .empty-state {
    text-align: center;
    padding: 40px 0;
    color: #909399;

    i {
      font-size: 48px;
      margin-bottom: 16px;
    }

    p {
      margin: 0 0 20px;
      font-size: 16px;
    }
  }
}

::v-deep .el-table .custom-row-bg {
}

::v-deep .el-table .custom-head-cell {
  background: #FF8833;
  color: white;
  box-sizing: border-box;
  font-family: GravityBold;
}
</style>
